import { hasAuthourity, isAgent } from './access.es6';

// Who may see what in the Commissions module.
//
// commission-service gates every administrative endpoint on the AGENT_ADMIN
// realm role: commission and clawback rules, batch payouts, agent and agency
// management, and every list and statistics endpoint. The MANAGE_COMMISSION_*
// roles this module used to read are real Keycloak roles, but the service never
// checks them, so a user holding one without AGENT_ADMIN was shown pages whose
// every request came back 403.
export function isCommissionsAdmin() {
  return hasAuthourity('AGENT_ADMIN');
}

// A self-service agent: an agent login that is not also an administrator.
//
// `is_agent` is a Keycloak user attribute, so this is a persona rather than a
// permission. An operator who merely holds AGENT_VIEW is not an agent and gets
// no Commissions menu at all, which is the right answer — AGENT_VIEW only ever
// buys read access to someone's record, never a commission account of one's own.
export function isCommissionsAgent() {
  return isAgent() && !isCommissionsAdmin();
}

export var AGENT_COMMISSIONS_PATH = 'commissions/my';

// Everything under Commissions a self-service agent may open. An allowlist, so
// a Commissions page added later is closed to agents until it is named here;
// the alternative leaks each new admin page by default.
var AGENT_PATHS = [AGENT_COMMISSIONS_PATH];

// Matches the route paths in routes/index.js, which are relative to /admin,
// and tolerates a full location pathname so a caller can pass either.
export function isAgentAllowedCommissionsPath(pathname) {
  var rest = String(pathname || '')
    .replace(/^\/?admin\/?/, '')
    .replace(/^\/+/, '')
    .replace(/\/+$/, '');

  for (var i = 0; i < AGENT_PATHS.length; i += 1) {
    if (rest === AGENT_PATHS[i]) return true;
    if (rest.indexOf(AGENT_PATHS[i] + '/') === 0) return true;
  }
  return false;
}
